import Entities from 'STORE';

export const clearNotifications = (): void => {
  Entities.pushNotifications.clearNotifications();
};
